import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { SectionTitle } from 'src/components/filter-section/components/section/styles';
import { OptionList } from 'src/components/filter-section/components/list/styles';

export const SelectedFiltersWrapper = styled.div`
  ${OptionList} {
    background: ${p => p.theme.colors.base100};
    padding: ${layout.measurements.spacing050} 0;
  }
`;

export const SelectedFiltersTitle = styled(SectionTitle).attrs({
  slim: true,
})``;
